import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=5cbf0122&scoped=true"
import script from "./fav.vue?vue&type=script&lang=js"
export * from "./fav.vue?vue&type=script&lang=js"
import style0 from "./fav.vue?vue&type=style&index=0&id=5cbf0122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf0122",
  null
  
)

export default component.exports